import { TitleWithDivider } from "@common/TitleWithDivider";

import UserInformation from "@components/Forms/UserProfileForm";
import pageHeaders from "@constants/PageHeaders";

const CreateUserPage: React.FC = () => {
  return (
    <>
      <div>
        <TitleWithDivider titleText={pageHeaders.USER.add} useDivider={true} />
        <UserInformation id="createUser"></UserInformation>
      </div>
    </>
  );
};

export default CreateUserPage;
